import { Injectable, Optional } from "@angular/core";
import { HttpClient, HttpErrorResponse } from "@angular/common/http";

import { Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";

import { ResourceApiInterface } from "@mo-tools-engine/common";
import { ResourceApiConfig } from "@mo-tools-engine/common";

import { Admin } from "./admin.model";

@Injectable()
export class SessionApiService implements ResourceApiInterface {
  private signOutUrl: string;
  private signInUrl: string;
  private baseUrl: string;

  // --- Service Constructor ---

  constructor(
    @Optional() sessionApiServiceConfig: ResourceApiConfig,
    private http: HttpClient
  ) {
    this.baseUrl = sessionApiServiceConfig.baseUrl;
    this.signInUrl = sessionApiServiceConfig.signInUrl;
    this.signOutUrl = sessionApiServiceConfig.signOutUrl;
  }

  // --- Session Service API ---

  public get(): Observable<Admin> {
    window.location.replace(this.signInUrl);
    return this.http
      .get<Admin>(this.signInUrl, {
        headers: { "Content-Type": "text/html; charset=UTF-8" },
      })
      .pipe(map(this.extractResourceData), catchError(this.handleError));
  }

  public delete(): Observable<any> {
    return this.http
      .delete<Admin>(this.signOutUrl)
      .pipe(map(this.extractResourceData), catchError(this.handleError));
  }

  // --- UNSUPPORTED Interface Methods ---

  public index(): Observable<any> {
    return throwError("Method not implemented");
  }

  public create(): Observable<any> {
    return throwError("Method not implemented");
  }

  public update(): Observable<any> {
    return throwError("Method not implemented");
  }

  // --- HTTP Callbacks ---

  private extractResourceData(response: Admin): any {
    return response;
  }

  private handleError(response: HttpErrorResponse): Observable<any> {
    let error = response;
    let errors = null;
    console.log(this.baseUrl);

    console.error("An error occurred", error);
    if ((error as any).errors) {
      errors = JSON.parse((error as any).errors);
    }

    return throwError(errors || error);
  }
}
